// SECȚIUNEA FÂȘIEI: ce se pune între fațadă și perete, desenat, nu scris.
//
// «R A R R A R R A R R A P» e exact ce trebuie ca să încapă pe o planșă și
// exact ce nu se poate citi. Aceeași informație desenată — mașini și alei, la
// scară — se citește dintr-o privire: câte rânduri, pe ce alee ies, cât de
// adâncă e fâșia.
//
// Desenul e în METRI: 1 unitate = 1 m, iar fâșia crește spre dreapta, de la
// fațadă (stânga) spre peretele excavației (dreapta). Așa, două fâșii puse una
// sub alta se compară direct.

/** Lățimile benzilor, în metri. Aceleași cu `benzi/banda.py` — dacă se schimbă
 *  acolo, desenul minte, deci sunt scrise o dată aici și nicăieri altundeva. */
const LAT: Record<string, number> = { A: 6, a: 5, R: 5, P: 2.5 };
const LOC_LAT = 2.5;      // lățimea unui loc, de-a lungul fațadei
const LOC_LUNG = 5;       // lungimea unui loc la 90°
const LOC_PARALEL = 5.75; // lungimea unui loc paralel

/** Cât din fațadă arătăm. Destul cât să se vadă că locurile se repetă, nu atât
 *  încât banda să devină un dreptunghi lung și ilizibil. */
const FATADA = 12;

export default function SectiuneFasie({ secventa, inaltime = 26 }:
                                      { secventa: string; inaltime?: number }) {
  const benzi = secventa.split(/\s+/).filter((c) => LAT[c]);
  if (!benzi.length) return null;
  const adanc = benzi.reduce((t, c) => t + LAT[c], 0);

  let x = 0;
  const forme: JSX.Element[] = [];
  benzi.forEach((tip, i) => {
    const w = LAT[tip];
    if (tip === "A" || tip === "a") {
      forme.push(<rect key={`b${i}`} x={x} y={0} width={w} height={FATADA} className="sf-alee" />);
      // linia de mijloc: semnul că e alee, nu spațiu liber
      forme.push(<line key={`m${i}`} x1={x + w / 2} y1={0.6} x2={x + w / 2} y2={FATADA - 0.6}
                       className="sf-ax" />);
    } else {
      // mașinile: la 90° stau cu lungimea pe adâncime, paralel cu lungimea de-a
      // lungul fațadei
      const perp = tip === "R";
      const pas = perp ? LOC_LAT : LOC_PARALEL;
      const lung = perp ? LOC_LUNG : LOC_PARALEL;
      const n = Math.floor(FATADA / pas);
      const sus = (FATADA - n * pas) / 2;
      for (let k = 0; k < n; k++) {
        forme.push(<rect key={`l${i}-${k}`} className="sf-loc"
                         x={x + (perp ? 0.12 : 0.12)} y={sus + k * pas + 0.12}
                         width={(perp ? lung : LAT.P) - 0.24} height={pas - 0.24} rx={0.3} />);
      }
    }
    x += w;
  });

  return (
    <svg className="sf" viewBox={`-0.3 -0.3 ${adanc + 0.6} ${FATADA + 0.6}`}
         height={inaltime} width={(inaltime * (adanc + 0.6)) / (FATADA + 0.6)}
         role="img" aria-label={`fâșie de ${adanc} m: ${secventa}`}>
      {forme}
      {/* fațada, în stânga: de la ea se măsoară tot */}
      <line x1={0} y1={-0.2} x2={0} y2={FATADA + 0.2} className="sf-fatada" />
      {/* peretele excavației, în dreapta */}
      <line x1={adanc} y1={-0.2} x2={adanc} y2={FATADA + 0.2} className="sf-perete" />
    </svg>
  );
}
